<template>
  <aside class="activity__details">
    <div class="activity__details-box">
      <Image v-if="activity.image" :source="activity.image" class="activity__details-image" />
      <div class="activity__details-content">
        <ActivityDetail :text="location" icon="location" />
        <ActivityDetail :text="date" icon="calendar" />
        <ActivityDetail :text="activity.details.pricing" icon="cost" />
        <ExternalLink :link="group.link" :label="$t('register')" class="--full --top" />
      </div>
    </div>
  </aside>
</template>

<script>
import { Image } from '@/components/global'
import { ActivityDetail, ExternalLink } from '@/components/small'
import { endDatePassedOrNull, humanDate } from '@/helpers'

export default {
  name: 'ActivityDetails',
  props: {
    activity: {
      type: Object,
      required: true,
    },
    groupId: {
      type: String,
      required: true,
    },
  },
  components: { ActivityDetail, ExternalLink, Image },
  computed: {
    date() {
      return endDatePassedOrNull(this.group.end_date)
        ? this.$t('timeless')
        : humanDate(this.group.start_date)
    },
    group() {
      return this.activity.groups[this.groupId]
    },
    location() {
      const location = `${this.group.location.type}`
      return this.group.location.name ? `${location} - ${this.group.location.name}` : location
    },
  },
  methods: { humanDate },
}
</script>
